Bingo.MobileFilterSwitcher = {};

Bingo.MobileFilterSwitcher.init = function () {
    $('.mobile-filter-switcher').each((index, item) => {
        $(item).click(function () {
            const filterArea = $('.filter.panel');
            const isHidden = filterArea.hasClass('mobile-filter-hidden');
            if (!$(this).data('show-text')) {
                $(this).data('show-text', $(this).text());
            }
            const showText = $(this).data('show-text');
            const hideText = $(this).data('hide-text');
            if (isHidden) {
                filterArea.removeClass('mobile-filter-hidden');
                $(this).text(hideText);
            } else {
                filterArea.addClass('mobile-filter-hidden');
                $(this).text(showText);
            }
            $(this).blur();
        });
    });
};

$(() => {
    Bingo.MobileFilterSwitcher.init();
});
